import { render, staticRenderFns } from "./DropdownCustomPositionSide.vue?vue&type=template&id=55744084&scoped=true&"
import script from "./DropdownCustomPositionSide.vue?vue&type=script&lang=js&"
export * from "./DropdownCustomPositionSide.vue?vue&type=script&lang=js&"
import style0 from "./DropdownCustomPositionSide.vue?vue&type=style&index=0&id=55744084&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55744084",
  null
  
)

export default component.exports